var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"main-panel"},[(_vm.app())?_c('top-navbar'):_vm._e(),_c('dashboard-content',{nativeOn:{"click":function($event){return _vm.toggleSidebar.apply(null, arguments)}}})],1)]),(_vm.logged())?_c('bottom-navbar'):_vm._e(),(_vm.logged())?_c('banner-treinamento'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }